angular.module('TetherApp').controller('LinkToolbarController', [
    '$window',
    'linkService',
    function (
        $window,
        linkService
    ) {
        let self = this;
        self.withTrashed = false;
    }
]);
